// @flow
import appConfig from "appConfig";
import {
	doLater,
} from "utils/domUtils";

export const fetchImage = (key: string, url: string): Promise<Object> => new Promise((resolve: Function) => {
	let timedOut = false;

	const img = new Image();
	img.src = url;

	const finish = (success = true, reason = null) => {
		if (!timedOut) {
			img.onload = null;
			img.onerror = null;
			resolve({
				key, url, success, reason, img,
			});
			clearTo();
		}
	};

	const clearTo = doLater(() => {
		finish(false, "timeout");
		timedOut = true;
	}, appConfig.customization.imageLoadTimeout);

	img.onload = () => {
		finish();
	};

	img.onerror = () => {
		finish(false, "fail");
	};
});

export default (images: Object): Promise<Object[]> => Promise.all(Object.keys(images).map((key) => fetchImage(key, images[key])));
